import * as React from "react";
import { Control, Errors } from "react-redux-form";
import {
    mapProps,
    showErrors,
    updateOn,
    validateOn
} from "./ReactReduxFormSettings";
import ValidationMessage from "./ValidationMessage";
import { required, numeric } from "../../../Common/validators";
import TextArea from "./TextArea";


export interface TextAreaControlProps {
    mandatory: boolean;
    model: string;
    readOnly?: boolean;
    type?: string;
    className?: string;
}

class TextAreaControl extends React.PureComponent<any, any> {
    render() {
        return (
            <div className={this.props.className}>
                <Control.text
                    className="form-control survey-textarea"
                    component={TextArea}
                    controlProps={{
                        label: "",
                        validate: true,
                        rows: this.props.rows,
                        type: this.props.type
                    }}
                    mapProps={mapProps}
                    model={this.props.model}
                    placeholder=""
                    readOnly={this.props.readOnly}
                    type={this.props.type}
                    updateOn={updateOn}
                    validateOn={validateOn}
                    validators={{
                        required: this.props.mandatory ? required : () => true,
                        numeric: this.props.type == "number" ? numeric : () => true
                    }}
                />
                <Errors
                    model={this.props.model}
                    messages={{
                        required: this.props.type == "number" ? "Please enter a numeric value" : "Please enter a value"
                    }}
                    className="invalid-feedback d-block"
                    show={showErrors}
                    component={ValidationMessage}
                />
            </div>
        );
    }
}

export default TextAreaControl;
